module.exports = __webpack_public_path__ + "static/media/envelope-solid-full.ca4bf8e3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/mm/envelope-solid-full.svg
// module id = 2591
// module chunks = 0